// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buy-button[data-v-5af0f62f]{position:relative;border-radius:0;color:#fff;border:none;cursor:pointer}.buy-button[data-v-5af0f62f]:not(:defined){display:none}.buy-button svg[data-v-5af0f62f]{position:absolute;right:15px;top:50%;transform:translateY(-50%);width:1em;height:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;stroke-width:0;stroke:currentColor;fill:currentColor}", ""]);
// Exports
module.exports = exports;
